import { render, staticRenderFns } from "./ForgotPasswordThanksPage.vue?vue&type=template&id=62e734a3&scoped=true"
import script from "./ForgotPasswordThanksPage.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordThanksPage.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordThanksPage.vue?vue&type=style&index=0&id=62e734a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e734a3",
  null
  
)

export default component.exports